/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_VariantInputs */

const en_mobile_ota_variant = /** @type {(inputs: Mobile_Ota_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variant`)
};

const es_mobile_ota_variant = /** @type {(inputs: Mobile_Ota_VariantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variante`)
};

/**
* | output |
* | --- |
* | "Variant" |
*
* @param {Mobile_Ota_VariantInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_variant = /** @type {((inputs?: Mobile_Ota_VariantInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_VariantInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_variant(inputs)
	return en_mobile_ota_variant(inputs)
});